import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';
//UI
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";
import { Input } from "../../../../ui/inputs/Input";
import { Mensaje } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';

export default function Departamentos({ show, setShow, onRecargar, operacion, id }) {
  var op = require('../../../../modulos/datos');
  let token = localStorage.getItem('jwtToken');
  let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [formData, setFormData] = useState({
    coddep: '',
    nomdep: ''
  });
  const [modoEdicion, setModoEdicion] = useState(false);
  const [registroCargado, setRegistroCargado] = useState(false);

  // Limpiar formulario
  const limpiarFormulario = () => {
    setFormData({
      coddep: '',
      nomdep: ''
    });
    setRegistroCargado(false);
    setModoEdicion(false);
  };

  // Formatear código con padding de ceros a 3 dígitos
  const formatearCodigo = (codigo) => {
    if (!codigo) return '';
    return codigo.toString().padStart(3, '0');
  };

  // Seleccionar registro para consulta/edición/eliminación
  const seleccionarRegistro = async (bloquear = true) => {
    if (!formData.coddep && !id) return false;

    const codigoABuscar = formData.coddep || id;
    const codigoFormateado = formatearCodigo(codigoABuscar);

    setFormData(prev => ({ ...prev, coddep: codigoFormateado }));
    setActivate(true);

    try {
      // Construir la consulta para obtener el departamento
      let campos = "coddep, nomdep";
      let nomtab = `nomi${codigoNomina}.departamento`;
      let condi = `coddep = '${codigoFormateado}'`;
      let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=coddep`;

      const response = await axios.get(endpoint, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200 && response.data && response.data.length > 0) {
        const registro = response.data[0];
        setFormData({
          coddep: registro.coddep || codigoFormateado,
          nomdep: registro.nomdep || ''
        });
        setRegistroCargado(true);

        // Si es edición, habilitar campos
        if (operacion === 2) {
          setModoEdicion(true);
        }
        // Si es consulta, inhabilitar campos
        else if (operacion === 4) {
          setModoEdicion(false);
        }
        // Si es eliminación, deshabilitar edición
        else if (operacion === 3) {
          setModoEdicion(false);
        }

        setActivate(false);
        return true;
      } else {
        setMensaje({
          mostrar: true,
          titulo: 'Información',
          texto: 'El Departamento no Existe',
          icono: 'warning'
        });
        setFormData(prev => ({ ...prev, coddep: '' }));
        setActivate(false);
        return false;
      }
    } catch (error) {
      console.error('Error al seleccionar registro:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message,
        icono: 'error'
      });
      setFormData(prev => ({ ...prev, coddep: '' }));
      setActivate(false);
      return false;
    }
  };

  // Actualizar (guardar) registro
  const actualizar = async () => {
    if (!validarCampos()) return false;

    setActivate(true);
    try {
      // Construir el endpoint según la operación
      let endpoint = `${op.conexion}/api/nomina/departamento_act`;

      const response = await axios.post(endpoint, {
        operacion: operacion,
        ccoddep: formatearCodigo(formData.coddep),
        cnomdep: formData.nomdep.toUpperCase(),
        esquema1: `nomi${codigoNomina}`
      }, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: 'Información',
          texto: `El registro fue ${operacion === 3 ? 'eliminado' : 'actualizado'} correctamente`,
          icono: 'exito'
        });



      }
    } catch (error) {
      console.error('Error al actualizar:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message,
        icono: 'error'
      });
      setActivate(false);
      return false;
    }
  };

  // Validar campos obligatorios
  const validarCampos = () => {
    if (!formData.coddep.trim()) {
      setMensaje({
        mostrar: true,
        titulo: 'Información',
        texto: 'El código del departamento no debe estar en blanco',
        icono: 'warning'
      });
      return false;
    }

    if (parseInt(formData.coddep) === 0) {
      setMensaje({
        mostrar: true,
        titulo: 'Información',
        texto: 'El código del departamento no debe ser cero',
        icono: 'warning'
      });
      return false;
    }

    if (!formData.nomdep.trim()) {
      setMensaje({
        mostrar: true,
        titulo: 'Información',
        texto: 'El nombre del departamento no debe estar en blanco',
        icono: 'warning'
      });
      return false;
    }

    return true;
  };

  // Manejar cambio en los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'coddep') {
      // Solo permitir números
      const soloNumeros = value.replace(/[^0-9]/g, '');
      if (soloNumeros.length <= 3) {
        setFormData(prev => ({ ...prev, [name]: soloNumeros }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  // Manejar Enter en campo código
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && formData.coddep.trim()) {
      seleccionarRegistro(operacion !== 4);
    }
  };

  // Manejar Aceptar
  const handleAceptar = async () => {
    if (operacion === 3) {
      // Confirmar eliminación
      const confirmar = window.confirm('¿Está seguro de eliminar el registro?');
      if (!confirmar) return;
      await actualizar();
    } else if (operacion === 2 || operacion === 1) {
      await actualizar();
    } else if (operacion === 4) {
      // Solo consulta, no guardar
      salir();
    }
  };

  // Manejar Cancelar
  const handleCancelar = () => {
    salir();
  };

  const salir = () => {
     setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
    setShow(false);
    limpiarFormulario();
  };

  // Cargar registro cuando se abre el modal y hay un ID
  useEffect(() => {
    if (show) {
      if (id && operacion !== 1) {
        // Modo edición, consulta o eliminación - cargar el registro
        setFormData(prev => ({ ...prev, coddep: id.toString() }));
        seleccionarRegistro(operacion !== 4);
      } else if (operacion === 1) {
        // Modo inclusión: habilitar campos y limpiar
        limpiarFormulario();
        setModoEdicion(true);
      }
    } else {
      // Modal cerrado, limpiar todo
      limpiarFormulario();
    }
  }, [show, id, operacion]);

  // Determinar si los campos están deshabilitados
  const camposDeshabilitados = () => {
    if (operacion === 4) return true; // Consulta: todos deshabilitados
    if (operacion === 3) return true; // Eliminación: solo mostrar, no editar
    if (operacion === 2 && !modoEdicion && registroCargado) return true; // Edición: deshabilitados hasta cargar
    if (operacion === 1) return false; // Inclusión: todos habilitados
    return !registroCargado;
  };

  // Título del modal según operación
  const getTitulo = () => {
    switch (operacion) {
      case 1: return 'Incluir Departamento';
      case 2: return 'Editar Departamento';
      case 3: return 'Eliminar Departamento';
      case 4: return 'Consultar Departamento';
      default: return 'Actualizar Departamentos';
    }
  };

  return (
    <Modal size="lg" show={show} onShow={() => {
      setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
    }} centered backdrop="static" keyboard={false} onHide={salir}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3 className="fw-bold m-0">{getTitulo()}</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={handleCancelar} style={{ cursor: 'pointer' }}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-4 d-flex flex-wrap">
        <div className="col-3 m-0 p-0">
          <Input
            label="Código:"
            name="coddep"
            value={formData.coddep}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            disabled={camposDeshabilitados() || (operacion === 2 && !registroCargado)}
            maxLength={3}
            placeholder="Código (3 dígitos)"
          />
        </div>
        <div className="col-9 m-0 p-0 pl-2">
          <Input
            label="Nombre:"
            name="nomdep"
            value={formData.nomdep}
            onChange={handleChange}
            disabled={camposDeshabilitados()}
            maxLength={100}
            placeholder="Nombre del departamento"
            inputClassName="text-uppercase"

          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        {operacion !== 4 && (
          <>
            <SuccessButton onClick={handleAceptar}>
              Aceptar
            </SuccessButton>
            <DangerButton onClick={handleCancelar}>
              Cancelar
            </DangerButton>
          </>
        )}
        {operacion === 4 && (
          <SuccessButton onClick={salir}>
            Cerrar
          </SuccessButton>
        )}
      </Modal.Footer>
      <Dimmer active={activate} inverted />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          if (mensaje.icono === 'exito') {
            onRecargar()
            salir();
          } else {
            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
        }}
      />
    </Modal>
  );
}